import React, { useState } from "react";
import "../Styles/Login.css";
import logo from "../assets/GMF logo no background.png";

const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const url = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            console.log(`Token sent to backend: ${token}`); // Ensure token is stored somewhere accessible like localStorage
            if (!token) {
                throw new Error("No token found. Please log in.");
            }

            const response = await fetch(
                `${url}/resetpassword`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ newPassword: password }),
                }
            );

            const data = await response.json();
            if (response.ok) {
                setMessage(data.message); // Assuming backend returns a success message
                setError("");
                setPassword(""); // Clear the input fields after successful reset
                setConfirmPassword("");
            } else {
                throw new Error(data.message || "Failed to reset password");
            }
        } catch (err) {
            setError(
                err.message || "Failed to reset password. Please try again."
            );
            setMessage(""); // Clear the success message on error
        }
    };

    // TODO: fix this up, actually connect it with backend
    return (
        <div className="login-container">
            <div className="logo-container">
                <img className="logo" src={logo} alt="MD-Sensei Logo"></img>
            </div>

            <div className="login-box">
                <h1>Reset Your Password</h1>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>New Password:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirm Password:</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit">Reset Password</button>
                </form>
            </div>

            {message && <p>{message}</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default ResetPassword;
